// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iv-0";
export var actionModalContentContainer = "_iv-1";
export var createTagButton = "_iv-2";
export var footerContainer = "_iv-7";
export var fullWidthDivider = "_iv-3";
export var hasCreateTagButton = "_iv-4";
export var noCreateTagButton = "_iv-5";
export var tagsContainer = "_iv-6";
export var tagsModalContentContainer = "_iv-8";